
export const mapCompanyRegisterToForm = (apiData) => {
    if (!apiData) return {};

    // Return a structure that matches CompanyDetailsForm state
    return {
        company_name: apiData.company_name || apiData.companyName || '',
        legal_entity_name: apiData.legal_entity_name || apiData.legalEntityName || '',
        corporate_email: apiData.corporate_email || apiData.corporateEmail || '',
        pan_tin: apiData.pan_tin || apiData.panTin || '',
        gstin: apiData.gstin || '',
        business_domain: apiData.business_domain || apiData.businessDomain || '',
        company_size: apiData.company_size || apiData.companySize || '',
        company_description: apiData.company_description || apiData.companyDescription || '',
        website_url: apiData.website_url || apiData.websiteUrl || '',

        contact_person_name: apiData.contact_person_name || apiData.contactPersonName || '',
        contact_email: apiData.contact_email || apiData.contactEmail || '',
        contact_phone: apiData.contact_phone || apiData.contactPhone || '',

        address_line_1: apiData.address_line_1 || apiData.addressLine1 || '',
        address_line_2: apiData.address_line_2 || apiData.addressLine2 || '',
        city: apiData.city || '',
        state: apiData.state || '',
        country: apiData.country || '',
        postal_code: apiData.postal_code || apiData.postalCode || ''
    };
};

export const mapCompanyProfileToForm = (apiData) => {
    if (!apiData) return {};

    // Helper to split string into array if needed
    const splitString = (str, delimiter = ',') => {
        if (!str) return [];
        if (Array.isArray(str)) return str;
        return str.split(delimiter).map(s => s.trim()).filter(Boolean);
    };

    // Helper to parse social handles string "Platform: URL | Platform: URL"
    const parseSocialHandles = (str) => {
        if (!str) return [];
        if (Array.isArray(str)) return str; // If already array (unlikely given save format)
        return str.split('|').map(item => {
            const [platform, url] = item.split(':').map(s => s.trim());
            return { platform: platform || '', url: url || '' };
        }).filter(h => h.platform || h.url);
    };

    // Helper to format logo
    const formatLogo = (url) => {
        if (!url) return null;
        return { url, name: 'Existing Logo', size: 0, type: 'image/*' };
    };

    // Helper to format brand assets
    const formatBrandAssets = (urls) => {
        const urlArray = splitString(urls);
        return urlArray.map(url => ({
            url, name: 'Brand Asset', size: 0, type: 'unknown'
        }));
    };

    return {
        industryDomains: apiData.industry_domains || apiData.industryDomains || [],
        yearsInOperation: apiData.years_in_operation?.toString() || apiData.yearsInOperation?.toString() || '',
        keyTechnologies: apiData.key_technologies || apiData.keyTechnologies || [],
        websiteUrl: apiData.website_url || apiData.websiteUrl || '',
        linkedinPage: apiData.linkedin_url || apiData.linkedinPage || '',
        otherSocialHandles: parseSocialHandles(apiData.other_social_handles || apiData.otherSocialHandles),
        logo: formatLogo(apiData.logo_url || apiData.logo),
        brandAssets: formatBrandAssets(apiData.brand_assets_url || apiData.brandAssets),
        // Keep potential old keys just in case
        overview: apiData.overview || '',
    };
};
